import { CurrencyItem, GetCurrencyListParams } from '@/models/dictionary/currency-list.model';
import { api } from '@/services/http.service';
import { showErrorNotification } from '@/utils/show-notification.util';
import { defineStore } from 'pinia';

interface CurrencyListState {
  currencyList: CurrencyItem[];
  fullCurrencyList: CurrencyItem[];
  isCurrencyListLoading: boolean;
}

export const useCurrencyListStore = defineStore({
  id: 'CurrencyListStore',
  state: (): CurrencyListState => ({
    currencyList: [],
    fullCurrencyList: [],
    isCurrencyListLoading: false,
  }),
  actions: {
    setCurrencyListLoading(isLoading: boolean): void {
      this.isCurrencyListLoading = isLoading;
    },
    getCurrencyList(params: GetCurrencyListParams): Promise<CurrencyItem[]> {
      if (this.currencyList.length > 0) {
        return Promise.resolve(this.currencyList);
      }

      this.setCurrencyListLoading(true);

      return api.dictionary.getCurrencyListRequest.perform(params)
        .then((currencyList: CurrencyItem[]) => {
          if (params.isFetchFullList) {
            this.fullCurrencyList = currencyList;
          } else {
            this.currencyList = currencyList;
          }

          return currencyList;
        })
        .catch(error => {
          showErrorNotification(error);

          return Promise.reject(error);
        })
        .finally(() => {
          this.setCurrencyListLoading(false);
        });
    },
  },
});
